import React from "react";
import { useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import Select from "react-select";

import {
  customStyles,
  customErrorStyles,
} from "./../../../../containers/AdministrativeProcedures/printCertificates/CertificateCardForPrint/optionsForCertificateCardPrint";

import styles from "./footerCertificateForPrint.module.css";

function FooterCertificateForPrint({ inputs, checkBoxInputs = null, data, handlerUpdateData, errors }) {
  const blocks = {
    ru: Object.values(inputs).filter((el) => !el?.eng),
    eng: Object.values(inputs).filter((el) => el.eng),
  };

  const usersLibrary = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.usersLibrary;
  });
  const userInfo = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.userInfo;
  });

  return (
    <div className={styles["content-container"]}>
      {checkBoxInputs ? (
        <Form.Group className={styles["checkbox-block"]}>
          <Form.Label className={styles["checkbox-label"]}>Действительно для:</Form.Label>
          <div className={styles["checkbox-container"]}>
            {Object.values(checkBoxInputs).map((input) => {
              return (
                <React.Fragment key={input.key}>
                  <input
                    type={input.type}
                    name={input.key}
                    id={input.key}
                    checked={Boolean(data[input.key])}
                    className={styles["checkbox-input"]}
                    onChange={(e) => handlerUpdateData(e)}
                  />
                  <label
                    className={styles?.["label"]}
                    htmlFor={input.key}>
                    {input.value}
                  </label>
                </React.Fragment>
              );
            })}
          </div>
        </Form.Group>
      ) : null}
      <div className={styles["inputs-container"]}>
        {Object.keys(blocks).map((blockType) => (
          <div
            key={blockType}
            id={`box-${blockType}`}
            className={styles[`box-${blockType}`]}>
            {blocks[blockType].map((input) => {
              if (input.show) {
                if (input.readOnly) {
                  return (
                    <div
                      key={input.key}
                      className={`${styles["text-block"]} ${styles[`box-${input.key}`]}`}>
                      <p className={styles["option-label"]}>{input.value}</p>
                      <p className={styles["option-value"]}>
                        {input.type === "selectWithSearch"
                          ? input.key === "inspector"
                            ? usersLibrary.find((elem) => elem.value === data?.inspector)?.name ||
                              usersLibrary.find((elem) => elem.value === userInfo?.userid)?.name
                            : input.options.find((elem) => elem.value === data?.[input.key])?.label || "—"
                          : input.type === "date" && data?.[input.key]
                          ? data?.[input.key].split("-").reverse().join(".")
                          : data?.[input.key] || "—"}
                      </p>
                    </div>
                  );
                } else {
                  if (input.type === "selectWithSearch") {
                    const selectedValue = input.options.find((elem) => elem.value === data[input.key]);
                    return (
                      <Form.Group
                        key={input.key}
                        controlId={`${input.key}`}
                        className={`${styles["common"]} `}>
                        <Form.Label>
                          {input.value}
                          {input.required && <span className={styles["red-dot"]}>*</span>}
                        </Form.Label>
                        <Select
                          noOptionsMessage={() => "Нет данных"}
                          value={selectedValue ? selectedValue : ""}
                          placeholder="Выберите"
                          id={input.key}
                          isDisabled={input.disabled || input === "view"}
                          name={input.key}
                          options={input.options}
                          styles={errors[input.key] ? customErrorStyles : customStyles}
                          onChange={(e) => handlerUpdateData(e)}
                        />
                        {errors[input.key] && (
                          <Form.Control.Feedback
                            type="invalid"
                            className={styles["error-message"]}>
                            {errors[input.key]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    );
                  }
                  return (
                    <Form.Group
                      key={input.key}
                      controlId={`${input.key}`}
                      className={`${styles["common"]} `}>
                      <Form.Label>
                        {input.value}
                        {input.required && <span className={styles["red-dot"]}>*</span>}
                      </Form.Label>
                      <Form.Control
                        type={input.type}
                        as={input.as}
                        placeholder="Введите"
                        value={data[input.key]}
                        readOnly={input.readOnly}
                        disabled={input.disabled}
                        onChange={(e) => handlerUpdateData(e)}
                        isInvalid={Boolean(errors[input.key])}
                        maxLength={input.maxLength}
                      />
                      {errors[input.key] && (
                        <Form.Control.Feedback
                          type="invalid"
                          className={styles["error-message"]}>
                          {errors[input.key]}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  );
                }
              }
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FooterCertificateForPrint;
